import request from "../http/request";
//调用微信sdk
export function getAuthInfo(params) {
  return request({
    url: "/api/wechat/wachat/page/auth",
    method: "get",
    params,
  });
}
